import React from 'react';

import { AlineAiAvatar, AlineAvatar } from 'src/components/AlineAvatar';
import type { AlineAvatarSize } from 'src/components/AlineAvatar';
import { makeStyles } from 'tss-react/mui';

import { getParticipantColor, getParticipantInitials } from './email-thread';

const useStyles = makeStyles()({
  avatar: {
    flexShrink: 0,
  },
});

/**
 * Initials on a color that stays the same for one person across the thread.
 * Aline itself gets the Aline AI avatar.
 */
export const EmailParticipantAvatar = React.memo(function EmailParticipantAvatar({
  colorKey,
  isAssistant = false,
  name,
  size = 'md',
}: {
  /** The address when known, so two people with one name still differ. */
  colorKey: string;
  name: string;
  isAssistant?: boolean;
  size?: AlineAvatarSize;
}) {
  const { classes } = useStyles();

  if (isAssistant)
    return <AlineAiAvatar aria-hidden className={classes.avatar} styles={{ size }} />;

  return (
    <AlineAvatar
      aria-hidden
      className={classes.avatar}
      styles={{ backgroundColor: getParticipantColor(colorKey), size }}
    >
      {getParticipantInitials(name)}
    </AlineAvatar>
  );
});
